"use strict";
export const statusList = [
  { label: "Init", value: "init" },
  { label: "Running", value: "running" },
  { label: "Complete", value: "complete" },
  { label: "Failure", value: "failure" },
  { label: "Terminated", value: "terminated" },
  { label: "Rollback", value: "rollback" }
];
